{
  "languageCode": "fr",
  "name": "Français",
  "direction": "ltr",
  "minimumWordLength": 2,
  "maximumWordLength": 12,
  "groups": [
    {
      "id": "vowel",
      "minimum": 5,
      "maximum": 8
    },
    {
      "id": "consonant",
      "minimum": 4,
      "maximum": 6
    }
  ],
  "letters": [
    {
      "id": "fr-0",
      "symbol": "a",
      "points": 1,
      "group": "vowel",
      "weight": 8.55,
      "enabled": true,
      "sortOrder": 0
    },
    {
      "id": "fr-1",
      "symbol": "b",
      "points": 3,
      "group": "consonant",
      "weight": 1.73,
      "enabled": true,
      "sortOrder": 1
    },
    {
      "id": "fr-2",
      "symbol": "c",
      "points": 2,
      "group": "consonant",
      "weight": 3.93,
      "enabled": true,
      "sortOrder": 2
    },
    {
      "id": "fr-3",
      "symbol": "d",
      "points": 3,
      "group": "consonant",
      "weight": 2.53,
      "enabled": true,
      "sortOrder": 3
    },
    {
      "id": "fr-4",
      "symbol": "e",
      "points": 1,
      "group": "vowel",
      "weight": 15.84,
      "enabled": true,
      "sortOrder": 4
    },
    {
      "id": "fr-5",
      "symbol": "f",
      "points": 4,
      "group": "consonant",
      "weight": 1.23,
      "enabled": true,
      "sortOrder": 5
    },
    {
      "id": "fr-6",
      "symbol": "g",
      "points": 3,
      "group": "consonant",
      "weight": 2.24,
      "enabled": true,
      "sortOrder": 6
    },
    {
      "id": "fr-7",
      "symbol": "h",
      "points": 3,
      "group": "consonant",
      "weight": 1.8,
      "enabled": true,
      "sortOrder": 7
    },
    {
      "id": "fr-8",
      "symbol": "i",
      "points": 1,
      "group": "vowel",
      "weight": 9.52,
      "enabled": true,
      "sortOrder": 8
    },
    {
      "id": "fr-9",
      "symbol": "j",
      "points": 8,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 9
    },
    {
      "id": "fr-10",
      "symbol": "k",
      "points": 8,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 10
    },
    {
      "id": "fr-11",
      "symbol": "l",
      "points": 2,
      "group": "consonant",
      "weight": 5.18,
      "enabled": true,
      "sortOrder": 11
    },
    {
      "id": "fr-12",
      "symbol": "m",
      "points": 2,
      "group": "consonant",
      "weight": 3.2,
      "enabled": true,
      "sortOrder": 12
    },
    {
      "id": "fr-13",
      "symbol": "n",
      "points": 1,
      "group": "consonant",
      "weight": 6.02,
      "enabled": true,
      "sortOrder": 13
    },
    {
      "id": "fr-14",
      "symbol": "o",
      "points": 1,
      "group": "vowel",
      "weight": 7.03,
      "enabled": true,
      "sortOrder": 14
    },
    {
      "id": "fr-15",
      "symbol": "p",
      "points": 3,
      "group": "consonant",
      "weight": 2.93,
      "enabled": true,
      "sortOrder": 15
    },
    {
      "id": "fr-16",
      "symbol": "q",
      "points": 4,
      "group": "consonant",
      "weight": 0.82,
      "enabled": true,
      "sortOrder": 16
    },
    {
      "id": "fr-17",
      "symbol": "r",
      "points": 1,
      "group": "consonant",
      "weight": 8.88,
      "enabled": true,
      "sortOrder": 17
    },
    {
      "id": "fr-18",
      "symbol": "s",
      "points": 2,
      "group": "consonant",
      "weight": 4.56,
      "enabled": true,
      "sortOrder": 18
    },
    {
      "id": "fr-19",
      "symbol": "t",
      "points": 1,
      "group": "consonant",
      "weight": 6.35,
      "enabled": true,
      "sortOrder": 19
    },
    {
      "id": "fr-20",
      "symbol": "u",
      "points": 2,
      "group": "vowel",
      "weight": 4.84,
      "enabled": true,
      "sortOrder": 20
    },
    {
      "id": "fr-21",
      "symbol": "v",
      "points": 4,
      "group": "consonant",
      "weight": 0.94,
      "enabled": true,
      "sortOrder": 21
    },
    {
      "id": "fr-22",
      "symbol": "w",
      "points": 10,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 22
    },
    {
      "id": "fr-23",
      "symbol": "x",
      "points": 5,
      "group": "consonant",
      "weight": 0.46,
      "enabled": true,
      "sortOrder": 23
    },
    {
      "id": "fr-24",
      "symbol": "y",
      "points": 5,
      "group": "consonant",
      "weight": 0.75,
      "enabled": true,
      "sortOrder": 24
    },
    {
      "id": "fr-25",
      "symbol": "z",
      "points": 8,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 25
    }
  ]
}
